import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { portalApi } from '@/api/portal'
import { Logo } from '@/components/shared/Logo'

export default function PortalMagicLinkVerifyPage() {
  const [searchParams] = useSearchParams()
  const { loginWithToken } = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState('')

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setError('No sign-in token found in this link.')
      return
    }

    portalApi.exchangeMagicLink(token)
      .then(({ data }) => {
        loginWithToken(data.accessToken)
        navigate('/portal/overview', { replace: true })
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail
        setError(detail ?? 'This sign-in link is invalid or has expired.')
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm text-center space-y-4">
        <Logo size={44} theme="light" />
        {error ? (
          <>
            <p className="text-sm font-medium text-red-600">{error}</p>
            <p className="text-sm text-slate-500">
              <Link to="/login" className="text-indigo-600 hover:text-indigo-700 underline">
                Back to sign in
              </Link>
            </p>
          </>
        ) : (
          <p className="text-sm text-slate-500">Signing you in…</p>
        )}
      </div>
    </div>
  )
}
